
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 13129","transform":"translate(-98 -1720)"}},[_c('circle',{attrs:{"data-name":"Ellipse 389","cx":"8.5","cy":"8.5","r":"8.5","transform":"translate(98 1720)","fill":"#f6b445"}}),_c('g',{attrs:{"data-name":"Group 13128"}},[_c('path',{attrs:{"data-name":"Rectangle 7415","d":"M105 1728h3v6h-3z"}}),_c('path',{attrs:{"data-name":"Rectangle 7416","d":"M105 1724h3v3h-3z"}})])])])
          )
        }
      }
    